import React from 'react';
import { Col, Container, ProgressBar, Row } from 'react-bootstrap';

const Skills = () => {
    return (
        <div id="resume" className="px-2 py-5">
            <Container>
                <div className="pb-5 text-center">
                    <h1 className="">Resume</h1>
                    <hr className="dash" />
                </div>
                <Row>
                    <div className="">

                        <h3><i className="fas fa-parachute-box text-info"></i> Skills</h3>
                    </div>
                    <Col lg={6}>
                        <div data-aos="fade-down-right" className="mt-4 px-2">
                            <div className="d-flex justify-content-between mb-0 pb-0">
                                <p>HTML & CSS</p>
                                <p>90%</p>
                            </div>
                            <div className="mt-0 pt-0">
                                <ProgressBar variant="info" style={{ height: '5px', }} now={90} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div data-aos="fade-down-left" className="mt-4 px-2">
                            <div className="d-flex justify-content-between mb-0 pb-0">
                                <p>Javascript</p>
                                <p>75%</p>
                            </div>
                            <div className="pb-0 mb-0 animate__animated animate__backInRight animate__delay-2s">
                                <ProgressBar variant="info" style={{ height: '5px', }} now={75} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div data-aos="fade-down-right" className="mt-4 px-2">
                            <div className="d-flex justify-content-between mb-0 pb-0">
                                <p>React</p>
                                <p>75%</p>
                            </div>
                            <div className="mb-0 pb-0">
                                <ProgressBar variant="info" style={{ height: '5px', }} now={75} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div data-aos="fade-down-left" className="mt-4 px-2">
                            <div className="d-flex justify-content-between mb-0 pb-0">
                                <p>Nodejs</p>
                                <p>50%</p>
                            </div>
                            <div className="mb-0 pb-0">
                                <ProgressBar variant="info" style={{ height: '5px', }} now={50} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div data-aos="fade-down-right" className="mt-4 px-2">
                            <div className="d-flex justify-content-between mb-0 pb-0">
                                <p>MongoDB</p>
                                <p>50%</p>
                            </div>
                            <div className="mb-0 pb-0">
                                <ProgressBar variant="info" style={{ height: '5px', }} now={50} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6}>
                        <div data-aos="fade-down-left" className="mt-4 px-2">
                            <div className="d-flex justify-content-between mb-0 pb-0">
                                <p>Bootstrap</p>
                                <p>85%</p>
                            </div>
                            <div className="mb-0 pb-0">
                                <ProgressBar variant="info" style={{ height: '5px', }} now={85} />
                            </div>
                        </div>
                    </Col>
                    <Col lg={6}></Col>
                </Row>
                <div className="mt-5 px-2">
                    <Row>
                        <h3><i className="fas fa-graduation-cap text-info"></i> Education</h3>
                        <Col md={6}>
                            <div data-aos="fade-down-right" className="mt-4">
                                <h5>BBA - Management</h5>
                                <p>2018 - Present</p>
                                <h4>Netrakona Govt. College</h4>
                            </div>
                        </Col>
                        <Col md={6}>
                            <div data-aos="fade-down-left" className="mt-4">
                                <h5>HSC</h5>
                                <p>2016 - 2018</p>
                                <h4>Royal Media College, Mymenshingh</h4>
                            </div>
                        </Col>
                    </Row>
                </div>

                <div className="pt-5 my-4 text-center">
                    <a target="_blank" href="https://drive.google.com/file/d/1ls2nf4TPup-FmWwZCPkrREDhdJBF5IxQ/view?usp=sharing">
                        <button className="btn btn-outline-info px-5 py-3 rounded-pill"><i class="far fa-arrow-alt-circle-down"></i> Download Resume</button>
                    </a>
                </div>
            </Container>
        </div>
    );
};

export default Skills;